import { render } from "./importSuccessful.vue?vue&type=template&id=2acb0ce9&scoped=true"
import script from "./importSuccessful.vue?vue&type=script&lang=js"
export * from "./importSuccessful.vue?vue&type=script&lang=js"

import "./importSuccessful.vue?vue&type=style&index=0&id=2acb0ce9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acb0ce9"]])

export default __exports__